import { apiMerchant } from "./config";

export const getTransactionData = (id, token) =>
  apiMerchant.get(`/merchant/checkout/${id}/${token}`).then((res) => res.data);

export const confirmTransaction = (id, token, payload) =>
  apiMerchant
    .patch(`/merchant/checkout/${id}/${token}`, payload)
    .then((res) => res.data);

export const cancelTransaction = (id, token) =>
  apiMerchant
    .patch(`/merchant/checkout/${id}/${token}/cancel`)
    .then((res) => res.data);

export const acceptTermsAndConfirm = (id, token, payload) =>
  apiMerchant
    .patch(`/merchant/checkout/${id}/${token}/accept-terms`, payload)
    .then((res) => res.data);

export const checkKycToken = (params) =>
  apiMerchant
    .get("/merchant/customers/kyc/check-token", { params })
    .then((res) => res.data);

export const registerOcr = (payload) =>
  apiMerchant
    .post("/merchant/customers/kyc/ocr/register", payload)
    .then((res) => res.data);

export const uploadDocument = (payload) =>
  apiMerchant
    .post("/merchant/customers/documents", payload)
    .then((res) => res.data);

export const getOcrProvider = (params) =>
  apiMerchant
    .get("/merchant/customers/kyc/ocr/provider", { params })
    .then((res) => res.data);

export const startOcrValidation = (payload) =>
  apiMerchant
    .post("/merchant/customers/kyc/ocr/start", payload)
    .then((res) => res.data);

export const registerTransactionCount = (id, token) =>
  apiMerchant
    .put(`/merchant/checkout/${id}/${token}/count`)
    .then((res) => res.data);
